
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SPORTS_LIST, COACH_TYPES, getSportSpecificCoachTypes } from '@/data/sportsData';

interface CoachSportsAndTypeSectionProps {
  primarySport: string;
  coachType: string;
  onPrimarySportChange: (sport: string) => void;
  onCoachTypeChange: (type: string) => void;
}

export const CoachSportsAndTypeSection: React.FC<CoachSportsAndTypeSectionProps> = ({
  primarySport,
  coachType,
  onPrimarySportChange,
  onCoachTypeChange
}) => {
  const availableCoachTypes = primarySport ? getSportSpecificCoachTypes(primarySport) : COACH_TYPES;

  return (
    <Card className="bg-gray-700 border-gray-600">
      <CardHeader>
        <CardTitle className="text-white text-lg">Primary Sport & Coach Type</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="primary_sport" className="text-gray-300">Primary Sport</Label>
            <Select value={primarySport} onValueChange={onPrimarySportChange}>
              <SelectTrigger className="bg-gray-600 border-gray-500 text-white">
                <SelectValue placeholder="Select your primary sport" />
              </SelectTrigger>
              <SelectContent className="bg-gray-600 border-gray-500 max-h-60">
                {SPORTS_LIST.map((sport) => (
                  <SelectItem key={sport} value={sport} className="text-white hover:bg-gray-700">
                    {sport}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <Label htmlFor="coach_type" className="text-gray-300">Coach Type</Label>
            <Select value={coachType} onValueChange={onCoachTypeChange}>
              <SelectTrigger className="bg-gray-600 border-gray-500 text-white">
                <SelectValue placeholder="Select coach type" />
              </SelectTrigger>
              <SelectContent className="bg-gray-600 border-gray-500 max-h-60">
                {availableCoachTypes.map((type) => (
                  <SelectItem key={type} value={type} className="text-white hover:bg-gray-700">
                    {type}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
